import React, { useState, useEffect } from "react";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
// import L from 'leaflet';
import DefaultIcon from "./LeafletIcon";
import "leaflet/dist/leaflet.css";
import "leaflet-defaulticon-compatibility";
import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css";

const fetchAddress = async (latitude, longitude) => {
    const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`
    );
    const data = await response.json();
    return data.display_name;
};

const DogLocationMap = ({ location, zoom = 13 }) => {
    const position = [location.latitude, location.longitude];
    const [address, setAddress] = useState("");

    useEffect(() => {
        const getAddress = async () => {
            const addr = await fetchAddress(
                location.latitude,
                location.longitude
            );
            setAddress(addr);
        };

        getAddress();
    }, [location]);

    return (
        <div className="mapContainer">
            <MapContainer
                center={position}
                zoom={zoom}
                scrollWheelZoom={false}
                style={{ height: "250px", width: "100%" }}
            >
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                />
                <Marker position={position} icon={DefaultIcon} />
            </MapContainer>
            <p>
                Last Known Location Address:{" "}
                <strong>{address || "Fetching address..."}</strong>
            </p>
        </div>
    );
};

export default DogLocationMap;
